export default __webpack_public_path__ + "static/media/FirstTopEllipse.7627d7b6.svg";